import Share from "@Common/Share";
import { getSqlServerGuidHash, sendMetric, randomNumber, pluralForm, getWhatId, clearParamWithoutRerender, getAbTestMetrika } from "@utils";
import dayjs from "dayjs";
import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";
import arrowBlack from "./img/arrow_black.svg";
import copyArrowBtnDark from "./img/arrow_btn.svg";
import copyDark from "./img/copy_dark.svg";
import copyGrey from "./img/copy_grey.svg";
import prize from "./img/gift_icon.gif";
import Timer from "./Timer";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const PromoModal = inject("mainStore")(
    observer(({ mainStore, mobile = false, modal = {} }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const [number, setNumber] = useState(5942);
        const [copyText, setCopyText] = useState(false);
        const [time, setTime] = useState("10:03");

        const { offerItem } = modal;
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);
        const id = offerItem && offerItem.vendor && offerItem.vendor._id ? offerItem.vendor._id : "";

        // Отслеживание нажатия кнопки Enter
        useEffect(() => {
            document.addEventListener("keyup", handlePressEnter);

            if (localStorage.getItem(id)) {
                setNumber(parseInt(localStorage.getItem(id)));
            } else {
                let num = randomNumber(5000, 25000);
                localStorage.setItem(id, num);
                setNumber(num);
            }

            return () => document.removeEventListener("keyup", handlePressEnter);
        }, []);

        useEffect(() => {
            let interval = setInterval(() => {
                let num = randomNumber(1, 10);
                localStorage.setItem(id, number + num);
                setNumber(number + num);
            }, 10000);

            return () => clearInterval(interval);
        }, [number]);

        // Событие по нажатию Enter
        const handlePressEnter = (event) => {
            if (event.code === "Enter") {
                let el = document.getElementById("button_copy");
                if (el) {
                    el.click();
                }
            }
        };

        const handleCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            sendMetric(`click_offer_accepted_copy_code`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
            navigator.clipboard.writeText(offerItem.promoCode).then(() => {
                setCopyText("Скопирован в буфер");
                setTimeout(() => {
                    setCopyText(false);
                }, 1000);
            });
        };

        const clickBtnCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            navigator.clipboard.writeText(offerItem.promoCode).then(() => {
                setTimeout(() => {
                    if (!localStorage.getItem("first_click_offer_go_to_site")) {
                        sendMetric(`first_click_offer_go_to_site`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: offerItem?._id,
                            params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                            params4: offerItem?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: what_id,
                        });

                        localStorage.setItem("first_click_offer_go_to_site", true);
                    }
                    sendMetric(`click_offer_accepted_сopy_code_go_to_site`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });

                    if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                        window.risMetrika.reachgoal_ch({
                            event: "click_offer_accepted_сopy_code_go_to_site",
                            siteId: what_id, //'id витрины',
                            offerId: offerItem?._id, //'id оффера'
                            variantCode: offerItem?._ab_code, //'в оффере новый ключ _ab_code',
                            position: offerItem?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                            sort: offerItem?.sortNum, //'Сортировка оффера на витрине!!!' ,
                            session_uuid: localStorage.getItem("_r_p_s"),
                            widget_code: wdCd ? wdCd : "",
                        });
                    }

                    const hrefOut = offerItem.activationLink.replace(/{{PROMOCODE}}/gim, offerItem.promoCode);
                    const a = document.createElement("a");
                    a.href = hrefOut;
                    a.target = "_blank";
                    a.click();
                    a.remove();
                    // navigation(location.pathname, { state: null })
                }, 500);
            });
        };

        const clickBtn = (e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!localStorage.getItem("first_click_offer_go_to_site")) {
                sendMetric(`first_click_offer_go_to_site`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });

                localStorage.setItem("first_click_offer_go_to_site", true);
            }

            sendMetric(`click_offer_accepted_go_to_site`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });

            const hrefOut = offerItem.activationLink.replace(/{{PROMOCODE}}/gim, offerItem.promoCode);

            const a = document.createElement("a");
            a.href = hrefOut;
            a.target = "_blank";
            a.click();
            a.remove();
        };

        const handleClose = () => {
            clearParamWithoutRerender(["id", "code"]);
            mainStore.setMainStore("modal", false);
        };

        const handleInstruction = () => {
            sendMetric("click_instruction_offer", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offerItem?._id,
                params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                params4: offerItem?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };


        return offerItem ? (
            <div className={`promo_modal_v2 ${mobile ? "mobile" : ""}`}>
                <div className="promo_modal_v2_mobile">
                    {!mobile ? (
                        <div className="content">
                            <div className={`content__img `}>
                                <img src={offerItem.cover || offerItem.vendor.logoList || ""} />
                                <Share offer={offerItem} />
                            </div>

                            {offerItem.offerType === "leads" ? null : <div className="content__title" dangerouslySetInnerHTML={{ __html: offerItem.title }} />}
                            <div className="offer__progressbar">
                                <div className="offer__progressbar-header">
                                    <img src={prize} />
                                    <span className="offer__progressbar-text">Активируйте предложение!</span>
                                    <span className="offer__progressbar-value" style={{ color: "#19B677" }}>
                                        {100}%
                                    </span>
                                </div>
                                <div className="offer__progressbar-line">
                                    <div className="line__filling" style={{ width: `100%` }}></div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="content">
                            <div className={`content__desc`}>
                                Сегодня это предложение забрали{" "}
                                <span>
                                    {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                                </span>
                            </div>
                        </div>
                    )}

                    {offerItem?.offerType && !["partnerlink", "leads"].includes(offerItem.offerType) ? (
                        <div className={`promo__code ${copyText ? "copy" : ""}`} onClick={(e) => handleCopy(e)}>
                            {copyText ? `${copyText}` : `${offerItem.promoCode}`}
                            <img src={copyText ? copyGrey : copyDark} />
                        </div>
                    ) : null}
                    {offerItem.offerType !== "leads" ? (
                        <div className="promo__copy" id="button_copy" onClick={offerItem?.offerType !== "partnerlink" ? (e) => clickBtnCopy(e) : (e) => clickBtn(e)}>
                            {offerItem?.offerType !== "partnerlink" && offerItem._id !== "662b6b30d07bd4eb3685f19b" && offerItem._id !== "65af6c1623f7b941440758ec" ? "Скопировать и перейти на сайт" : "Перейти на сайт"}
                            <img src={copyArrowBtnDark} width={21} />
                        </div>
                    ) : (
                        <span className="content__text_default">
                            <span>Спасибо за вашу заявку!</span>
                            <span>наш менеджер скоро с вами свяжется</span>
                        </span>
                    )}

                    {offerItem.offerType !== "leads" ? (
                        <div className="promo__timer">
                            <span className="promo__text">Успейте активировать:</span>
                            <Timer endDate={dayjs()} />
                        </div>
                    ) : (
                        <div className={`promo__button`} onClick={() => handleClose(true)}>
                            Выбрать еще предложения
                        </div>
                    )}
                </div>

                {offerItem?.offerDetail?.miniDisc ? <div className="promo_v2_subdescription" onClick={handleInstruction} dangerouslySetInnerHTML={{ __html: offerItem?.offerDetail.miniDisc }}></div> : null}
                {!mobile ? null : (
                    <div className="promo_v2_button">
                        <span>Скрыть предложение</span> <img src={arrowBlack} />
                    </div>
                )}
            </div>
        ) : null;
    }),
);

export default PromoModal;
